<template>
  <a-modal destroyOnClose style="height: 80%;overflow-y: auto;" width="80%" v-model="visible" @cancel="close" @ok="handleOk" cancelText="关闭" okText="提交" :closable="false" :maskClosable="false">
    <a-row slot="title" style="margin-bottom: 10px">
      <a-row>
        复诵题
      </a-row>
    </a-row>
    <a-spin :spinning="loading">
      <a-row>
        <a-form-model :label-col="labelCol" :wrapper-col="wrapperCol">
          <a-form-model-item label="是否必做">
            <a-radio-group :options="requiredOptions" v-model="drill.required"/>
          </a-form-model-item>
          <a-form-model-item label="题图">
            <CommonUpload :defaultUrl="drill.imageUri ? `${$ossHost}${drill.imageUri}`: undefined" @changeImgUri="changeImgUri" path="img/drill/"/>
          </a-form-model-item>
          <a-form-model-item label="句子音频">
            <AudioUpload :defaultUrl="drill.audioUri ? `${$ossHost}${drill.audioUri}`: undefined" @changeUri="changeAudioUri" path="audio/drill/"/>
          </a-form-model-item>
          <a-form-model-item label="注音文本">
            <a-input style="width: 90%" v-model="drill.markedText"/><a-button style="width: 10%" type="primary" @click="saveMarketText">解析</a-button>
            <div>
              <span>
                <template v-for="(text, index) in drill.displayText">{{text.word}}{{text.after}}</template>
              </span>
            </div>
            <a-row style="margin-top: 5px">
              <a-col :span="23">
                <a-tag :key="index" v-for="(text, index) in drill.refText">
                  {{text.word}}
                </a-tag>
              </a-col>
            </a-row>
          </a-form-model-item>
          <a-form-model-item label="提示">
            <a-input v-model="drill.tips"/>
          </a-form-model-item>
          <a-form-model-item label="翻译">
            <a-input v-model="drill.translatedText"/>
          </a-form-model-item>
          <a-form-model-item label="解析">
            <a-textarea style="width: 80%" v-model="drill.explanation" placeholder="请输入解析"/>
          </a-form-model-item>
        </a-form-model>
      </a-row>
    </a-spin>
  </a-modal>
</template>

<script>
import {mapActions} from "vuex";
const OSS = require('ali-oss')
const letter = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'
import AudioUpload from '../../../../components/AudioUpload.vue'
import CommonUpload from '../../../../components/CommonUpload.vue'
import FileContentUpload from '../../../../components/FileContentUpload.vue'
import ReadbackDrillApi from '../../../../api/src/drill/api/ReadbackDrillApi.js'
import DrillApi from '../../../../api/src/drill/api/DrillApi.js'
import Row from '../../../chip/lib/row.vue';
const readbackDrillApi = new ReadbackDrillApi()
const drillApi = new DrillApi()
export default {
  name: "DialogueEdit",
  props: {
    visibleTimes: Number,
    info: Object,
    treeData: Array,
    subType: Number,
    selectedKeys: Array,
    currentDrillId: String,
    sectionId: String,
  },
  components: {AudioUpload, FileContentUpload, CommonUpload, Row},
  watch: {
    'visibleTimes': async function(a, b) {
      this.visible = true
      this.actorMap = {}
      if(this.currentDrillId){
        console.debug(this.currentDrillId)
        this.loading = true
        let resp = await readbackDrillApi.getDetail(this.currentDrillId)
        this.drill = resp
        console.debug(resp)
        this.loading = false
        return
      }
    },
  },
  data() {
    return {
      letter: letter,
      labelCol: { span: 4 },
      wrapperCol: { span: 20 },
      formItemLayoutWithOutLabel: {
        wrapperCol: {
          xs: { span: 24, offset: 0 },
          sm: { span: 20, offset: 4 },
        },
      },
      requiredOptions: [{
        value: false,
        label: '否'
      },{
        value: true,
        label: '是'
      }],
      drill: {
        audioUri: undefined,
        required: false,
        tips: undefined,
        markedText: undefined,
        displayText: [],
        refText: [],
        iseText: undefined,
        translatedText: undefined,
        imageUri: undefined,
        explanation: undefined,
      },
      fragmentList: [],
      uploading: false,
      loading: false,
      visible: false,
      actorMap: {}
    }
  },
  methods:{
    async saveMarketText() {
      this.loading = true
      let markedText = this.drill.markedText
      console.log(markedText)
      let resp = await drillApi.parseMarkedText(markedText)
      console.log(resp)
      this.drill.displayText = resp.displayText
      this.drill.refText = resp.refText
      this.drill.iseText = resp.iseText
      this.loading = false
      console.log(this.drill)
    },
    changeImgUri(uri) {
      this.drill.imageUri = uri
      console.log(uri)
    },
    changeAudioUri(uri) {
      this.drill.audioUri = uri
      console.log(uri)
    },
    close() {
      if(this.loading){
        this.$message.warning('试题正在上传中，请稍后')
        return
      }
      this.$emit('success', {addDrill: true})
      this.visible = false
      this.drill = {
        audioUri: undefined,
        required: false,
        tips: undefined,
        markedText: undefined,
        displayText: [],
        refText: [],
        iseText: undefined,
        translatedText: undefined,
        imageUri: undefined,
        explanation: undefined,
      }
    },
    async handleOk() {
      console.log(this.drill)
      if(!this.drill.markedText){
        this.$message.error('请填写注音文本并解析')
        return
      }
      if(this.drill.refText.length == 0 || !this.drill.iseText){
        this.$message.error('请解析注音文本')
        return
      }
      if(!this.drill.audioUri && !this.drill.audioUrl){
        this.$message.error('请上传句子音频')
        return
      }
      if(!this.drill.id){
        this.drill.subType = this.subType
      }
      console.debug(this.drill)
      console.debug(this.$route.params.courseStandardId)
      console.debug(this.selectedKeys[0])
      this.loading = true
      if(!this.drill.id){
        await readbackDrillApi.create(this.drill, {
          courseStandardId: this.$route.params.courseStandardId,
          knowledgeId: this.selectedKeys[0],
          sectionId: this.sectionId,
          sortKey: 0
        })
      }else{
        await readbackDrillApi.update(this.drill.id, this.drill)
      }
      this.visible = false
      this.drill = {
        audioUri: undefined,
        required: false,
        tips: undefined,
        markedText: undefined,
        displayText: [],
        refText: [],
        iseText: undefined,
        translatedText: undefined,
        imageUri: undefined,
        explanation: undefined,
      }
      this.loading = false
      this.$emit('success', {addDrill: true})
    }
  }
}
</script>

<style scoped lang="less">
.dynamic-delete-button {
  cursor: pointer;
  position: relative;
  top: 4px;
  font-size: 24px;
  color: #999;
  transition: all 0.3s;
  margin-left: 10px;
}
.dynamic-delete-button:hover {
  color: #777;
}
</style>